type StorageLike = Pick<Storage, 'getItem' | 'setItem' | 'removeItem' | 'clear'>;

const getNativeStorage = (): StorageLike | null => {
  if (typeof window === 'undefined') {
    return null;
  }
  try {
    return window.localStorage ?? null;
  } catch {
    return null;
  }
};

export const storage = {
  getItem(key: string): string | null {
    const store = getNativeStorage();
    if (!store) return null;
    try {
      return store.getItem(key);
    } catch {
      return null;
    }
  },

  setItem(key: string, value: string): boolean {
    const store = getNativeStorage();
    if (!store) return false;
    try {
      store.setItem(key, value);
      return true;
    } catch {
      return false;
    }
  },

  removeItem(key: string): void {
    const store = getNativeStorage();
    if (!store) return;
    try {
      store.removeItem(key);
    } catch {
      // ignore
    }
  },

  clear(): void {
    const store = getNativeStorage();
    if (!store) return;
    try {
      store.clear();
    } catch {
      // ignore
    }
  },

  getJson<T>(key: string, fallback: T | null = null): T | null {
    const raw = this.getItem(key);
    if (!raw) return fallback;
    try {
      return JSON.parse(raw) as T;
    } catch {
      return fallback;
    }
  },

  setJson(key: string, value: unknown): boolean {
    if (value === undefined || value === null) {
      this.removeItem(key);
      return true;
    }
    try {
      return this.setItem(key, JSON.stringify(value));
    } catch {
      return false;
    }
  },
};

export type StorageFacade = typeof storage;
